enum InternalChatSubject {
    Vehicle = 1,
    Customer = 2,
}

export default InternalChatSubject;
